import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import gSteps from "@/components/g-steps/g-steps.vue"
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import CartaPropostaController from "@/shared/controllers/cartaProposta/CartaPropostaController";

export default {
  name:'GerarCartaPropostaPagamento',
  components:{
    'g-card': gCard,
    'g-form': gForm,
    'g-button': gButton,
    'g-steps': gSteps,
  },


  setup(){
    return {
      v$: useVuelidate()
    }
  },


  mounted() {
    this.populaTipoPagamento()
    this.populateTipoCarta()
    this.ImagemEmpresa()

  },


  data () {
    return {
      imagemEmpresa: '',
      porcentagemArray: [],
      cartaArray:[],
      cartaSelecionada: undefined,
      formaDePagamentoArray:[],
      formaDePagamentoSelecionado: undefined,
      porcentagemFinal:"0%",
      autorizaPrazoBool: false,
      TemAlgumaSolicitacao: false,
      TemSolicitacaoAutorizada: null

    }

  },

  validations() {
  return {
    formaDePagamentoSelecionado:{ required: helpers.withMessage('O campo Forma de Pagamento é obrigatório', required)},
    cartaSelecionada:{ required: helpers.withMessage('O campo Tipo de Carta é obrigatório', required) },
}
},

  methods: {
    ImagemEmpresa(){
      CartaPropostaController.GetNomeEmpresaByCartaId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `//${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    populateTipoCarta() {
      this.$isLoading(true)
      this.axios({
        method: "get",
        url: process.env.VUE_APP_WEB_API + "CartaProposta/GetTipoCartaEnum",
      })
        .then((response) => {
          this.$isLoading(false)
          this.cartaArray = response.data
        })
        .catch(() => {
        });
    },


    porcentagem(idSelecionado){
      this.formaDePagamentoArray.forEach(obj=>{
        if(obj.id === idSelecionado){
          this.porcentagemFinal = obj.porcentagemFinanceira
        }
      })
    },


    populaCartaPropostaPagamento(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + (`CartaProposta/GetPagamentosSelecionados/${this.$route.params.id}`),
      })
      .then((response) => {
        this.$isLoading(false)

        if(response.data.code == -500)
        {
          this.GetPagamentoDoOrcamentoSelecionado()
        }
        else{
          this.AutorizaPrazoBool = response.data.data.autorizaPrazoBool
          this.formaDePagamentoSelecionado = response.data.data.id;

          this.cartaSelecionada = response.data.data.tipoCarta;
      
          if ( this.formaDePagamentoArray.find(f => f.id == this.formaDePagamentoSelecionado) != undefined) {
            this.porcentagemFinal = response.data.data.porcentagemFinanceira;
          }


        }
        })
        .catch(() => {
        })
      },

      GetPagamentoDoOrcamentoSelecionado(){

        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + (`CartaProposta/GetFormaPagamentoDoOrcamento/${this.$route.params.id}`),
        })
        .then((response) => {
          this.$isLoading(false)
            this.formaDePagamentoSelecionado = response.data.data.formaPagamentoId;
            this.porcentagemFinal = response.data.data.porcentagemFinanceira;
            this.cartaSelecionada = response.data.data.tipoCarta;
          })
          .catch(() => {
          })

      },

      VerificaSolicitacaoPrazoAutorizada(){

        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + (`SolicitacaoAutorizacao/VerificaSolicitacaoPrazoAutorizada/${this.$route.params.id}`),
        })
        .then((response) => {
          this.$isLoading(false)
          if(response.data.data == null)
          {
            this.TemAlgumaSolicitacao = false
            this.TemSolicitacaoAutorizada = null;
            this.populaCartaPropostaPagamento()
          }
          else{
            this.TemSolicitacaoAutorizada = response.data.data.status;
            if(response.data.data.status == 1)
            {
              this.TemAlgumaSolicitacao = true
              this.GetPagamentoDoOrcamentoSelecionado()
              
            }
            else
            {
              this.TemAlgumaSolicitacao = false
              this.populaCartaPropostaPagamento()
            }
          }
          

          })
          .catch(() => {
          })

      },

    insertPagamentoCartaProposta() {
      this.$isLoading(true)
      this.axios({
        method: "post",
        url: process.env.VUE_APP_WEB_API + 'CartaProposta/InsertPagamentoCartaProposta/post',
        data: {
          CartaPropostaId: this.$route.params.id,
          FormaPagamentoId: this.formaDePagamentoSelecionado,
          TipoCarta : this.cartaSelecionada,
          TemAlgumaSolicitacao: this.TemAlgumaSolicitacao
        }
      }).then(() => this.$router.push(`/gerar-carta-proposta/${this.$route.params.id}/markup`))
      .finally(() => this.$isLoading(false))
  },


    populaTipoPagamento() {
      // let formaPagamento={}
      this.$isLoading(true)
      this.axios({
        method: "get",
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetFormaPagamento/${this.$route.params.id}`,
      })
        .then((response) => {
          this.$isLoading(false)
          this.formaDePagamentoArray = response.data.data
          // response.data.data.forEach(obj=>{
          //   formaPagamento={id: obj.id , formaDePagamento : obj.formaDePagamento, porcentagemFinanceira: obj.porcentagemFinanceira}
          //   this.formaDePagamentoArray.push(formaPagamento)
          // })
          this.VerificaSolicitacaoPrazoAutorizada()

        })
        .catch(() => {
        });

      },


    step3 () {
      if(this.v$.$invalid === true){
        this.v$.$silentErrors.forEach(error=>{
          this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
        })
      }else{
        this.insertPagamentoCartaProposta()
      }
    },

      VoltarStep1 () {
        this.$router.push(`/gerar-carta-proposta/${this.$route.params.id}/orcamento`)
      }
  }
}